import { AnaColumn } from "../forms-template.service";
import { aspect } from "./aspect";
import { createGridConfig, gridSimple } from "./gridSettings/gridSettings";
export const listaCer: AnaColumn[] = [
    {
      itemType: "group", colCount: "1", data: [
       
        {
          type: 'campoSpecial',
          dataField: 'id',
          dataType: '',
          caption: 'EER',
          colWidth:'120',
          orderGriglia: 1,
          maxLength: '6',
          colVisible: true,
         showClearButton:false,
          labelVisible: true,
          validation: [
            { type: 'required', message: 'Campo obbligatorio' }
          ],
          dynamic: {
            dataSource: 'cer',
            service: 'cer',
            autocomplete: false,
            queryString:"?$filter=(not endswith(id,'00'))",
            valueExpr: 'id',
            displayExpr: 'id', 
            caption: 'Lista EER',
            componentType: 'dynamicGrid',
            related:['descrizione'],
          
            buttonOption: {
              text: 'Codici CER',
              icon: 'glyphicon mdi mdi-playlist-plus',
              hint: 'Sfoglia Lista codici CER',
              name: 'CodiciCERLista',
              location: 'after',
            },
            settingGrid: gridSimple
          }
        },
  
        {
          type: 'campo',
          dataField: "descrizione",
          caption: 'Descrizione',
          colVisible: true,
          cellTemplate: true,
          disableOnUpdate: true,
          hideOnEdit: true,
          colWidth:'700',
          allowEditing:false
  
  
        },
      ]
    },
  ]